import { zergApi } from "@/service/zerg";

class TransactionsService {

    async getTransactions(params) {
        try {
            const data = await zergApi.get("/bookeeping/transactions/index", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TransactionsService();